import { siteInfo } from "@/mocks/comics";
import SectionHeading from "./SectionHeading";

const testimonials = [
  {
    name: "追更达人·小鹿",
    role: "奇幻悬疑爱好者",
    text: "以前找韩漫全靠碰运气，现在看漫潮的榜单就够了，每周更新很及时，推荐的作品几乎没有踩雷的。",
  },
  {
    name: "阿宇",
    role: "热血向读者",
    text: "分类做得很细，想找的题材一眼就能看到。专题展示的评分和简介也很靠谱，帮我补上了不少错过的好作品。",
  },
  {
    name: "咸鱼追漫中",
    role: "日常治愈党",
    text: "最喜欢新作速递板块，新面孔更新很勤，画风审美在线，追更节奏安排得明明白白，非常省心。",
  },
];

export default function About() {
  return (
    <section id="about" className="relative py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="About 关于漫潮"
          title="把值得追的韩漫，认真讲给你听"
          desc={siteInfo.intro}
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* principles */}
          <div>
            <h3 className="text-lg md:text-xl font-black text-foreground-950 mb-5">我们的内容原则</h3>
            <div className="space-y-4">
              {siteInfo.principles.map((p, i) => (
                <div
                  key={i}
                  className="flex items-start gap-4 p-4 rounded-2xl bg-background-50 border border-background-200"
                >
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-xl bg-primary-500 text-background-50 font-display text-lg">
                    {i + 1}
                  </span>
                  <p className="text-sm text-foreground-700 leading-relaxed pt-1">{p}</p>
                </div>
              ))}
            </div>

            {/* reputation stats */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-6">
              {[
                { num: "240+", label: "精选作品" },
                { num: "96%", label: "读者好评" },
                { num: "40+", label: "栏目专题" },
                { num: "5年", label: "持续更新" },
              ].map((s) => (
                <div key={s.label} className="p-4 rounded-2xl bg-background-50 border border-background-200 text-center">
                  <div className="text-xl md:text-2xl font-black text-primary-500">{s.num}</div>
                  <div className="text-[11px] md:text-xs text-foreground-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* testimonials */}
          <div>
            <h3 className="text-lg md:text-xl font-black text-foreground-950 mb-5">读者口碑</h3>
            <div className="space-y-4">
              {testimonials.map((t) => (
                <figure
                  key={t.name}
                  className="p-5 rounded-2xl bg-background-50 border border-background-200"
                >
                  <i className="ri-double-quotes-l text-accent-500 text-2xl"></i>
                  <blockquote className="text-sm text-foreground-700 leading-relaxed mt-2">{t.text}</blockquote>
                  <figcaption className="flex items-center gap-3 mt-4">
                    <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 font-bold text-sm">
                      {t.name[0]}
                    </span>
                    <div>
                      <div className="text-sm font-bold text-foreground-950">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}